module.exports = __webpack_public_path__ + "img/622-42dfb3.png";